/**
 * RFC 7807 problem `type` URIs for finance business errors. Match on these
 * via `getApiError(error)` instead of parsing `detail`. Mirrors the backend
 * `App\Finance\Enum\FinanceErrorType`.
 */
export const FinanceErrorType = {
  InvoicePaidImmutable: '/errors/invoice-paid-immutable',
  InvoicePaidAmountExceedsTotal: '/errors/invoice-paid-amount-exceeds-total'
} as const

export type FinanceErrorType =
  (typeof FinanceErrorType)[keyof typeof FinanceErrorType]
